export default "__VITE_ASSET__Cv9JwacP__"